<template>
  <div>
    <b-modal
      id="modal-updateCredit"
      ref="updateCredit"
      hide-footer
      centered
      title="Modifier le statut d'un article"
    >
      <div class="pl-lg-4">
        <div class="row">
          <div class="col-12">
            <div>
              <center>
                <base-input
                  alternative
                  label="Credit"
                  placeholder="Credit"
                  input-classes="form-control-alternative"
                  v-model="model.credit"
                />
              </center>
            </div>
          </div>
        </div>
        <!--  <div class="row">
       
          </div>-->
      </div>

      <hr class="my-4" />
      <!-- Description -->
      <center>
        <b-btn
          type="submit"
          style="background-color: #c2b59b; color: #fff"
          @click="UpdateClientCredit()"
          >Modifier</b-btn
        >
      </center>
    </b-modal>
  </div>
</template>
<script>
import { put } from "@/mixins/api";
export default {
  name: "ModalUpdateClient",
  data() {
    return {
      modalupd: false,
      model: {
        credit: 0,
        id: "",
      },
      selectedStatus: undefined,
      limit: 0,
      credit: 0,
    };
  },
  methods: {
    makeToast(msg, variant = null) {
      this.$bvToast.toast(msg, {
        title: "Modification crédit",
        variant: variant ? variant : "danger",
        solid: true,
      });
    },
    setId(id, credit, limit) {
      this.model.id = id;
      this.credit = credit;
      this.limit = limit;
      this.$refs.updateCredit.show();
    },
    UpdateClientCredit() {
      try {
        console.log(this.model);
        let credit = parseFloat(this.model.credit);
        if (credit > this.limit) {
          this.makeToast("Le crédit est supérieur au montant autorisé.");
          return;
        }
        credit += this.credit;
        put("client/credit/" + this.model.id, { credit }).then((res) => {
          this.$emit("updated");
          this.$refs.updateCredit.hide();
        });
      } catch (e) {
        console.log(e);
        this.makeToast("Vérifiez les données que vous avez saisit.");
      }
    },
  },
  mounted() {},
};
</script>
                        